import React from "react";

const NoEmailSection = () => (
  <div className="text-left space-y-3">
    <p className="text-gray-500">
      Para crear una cuenta en la app necesitas un correo electrónico. Aquí
      tienes dos opciones:
    </p>
    <ul className="list-disc list-inside space-y-1 text-gray-500">
      <li>Crear un correo de Gmail (gratis y permanente).</li>
      <li>
        Usar un servicio de correo temporal, solo si quieres crear la cuenta
        rápido.
      </li>
    </ul>
    <div className="flex justify-center pt-1">
      <a
        href="https://temp-mail.org/es/"
        target="_blank"
        rel="noopener noreferrer"
        className="px-5 py-2 rounded-full font-bold text-sm active:scale-95 transition-transform bg-violet-300/[0.15] text-brand-muted border-[1.5px] border-violet-300"
      >
        📧 Crear correo temporal
      </a>
    </div>
  </div>
);

export default NoEmailSection;
